// Shared Framer Motion variants for consistent section/card entrances.
//
// MGS MOTION LANGUAGE (Pass 2)
// ----------------------------
// - Easing:    [0.22, 1, 0.36, 1] for entrances; spring (260–360 stiffness, 22 damping) for hover.
// - Durations: entrances 0.55–0.75s; micro-interactions 150–250ms.
// - Choreography: section heading wipes up → gradient divider draws L→R → content stagger.
// - Stagger:   children 0.06–0.12s, delayChildren 0.05–0.15s.
// - Signature: hero "AI Core" (drawn-in network + pulsing nodes + conic ring).
// - Globals:   gold scroll-progress bar; magnetic-sheen primary buttons; tilt cards.
// All non-essential motion is disabled when prefers-reduced-motion is set (see index.css).
export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.6, ease: 'easeOut' } },
};

export const staggerParent = (stagger = 0.08, delayChildren = 0.05) => ({
  hidden: {},
  show: {
    transition: { staggerChildren: stagger, delayChildren },
  },
});

export const cardPop = {
  hidden: { opacity: 0, y: 24, scale: 0.98 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

export const viewportOnce = { once: true, amount: 0 };
